import { useRememberedAdminUserInfo } from 'src/services'

// The admin id the session token carries while impersonating (the gateway
// reads the same `adminId` claim). Only a fallback for when the remembered-
// admin query has not answered or failed; never used to authorize anything.
const adminIdFromToken = (): string | null => {
  try {
    const payload = (window.localStorage.getItem('token') || '').split('.')[1]
    if (!payload) return null
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const adminId = JSON.parse(json)?.adminId
    return adminId ? String(adminId) : null
  } catch {
    return null
  }
}

// The admin impersonating the customer, or null for the customer themselves.
// Falls back to the session token so the way out and the no-save guards stay
// in place if the remembered-admin query is loading or failed (review
// 2026-10-07).
export const useImpersonatingAdminId = (): string | null => {
  const { rememberedAdminUser } = useRememberedAdminUserInfo() || {}
  return rememberedAdminUser?.id ?? adminIdFromToken()
}

// True while an admin is impersonating the customer. They see what the
// customer sees, but reading notifications, acknowledging an announcement or
// skipping the welcome flow must not be saved as if the customer did it
// (product, 2026-10-07). Billing actions are not covered: those are real.
export const useIsImpersonating = (): boolean => Boolean(useImpersonatingAdminId())
